import React from 'react'
import update from 'immutability-helper';
import DropzoneComponent from 'react-dropzone-component';

import TenantsSelect from '../../components/Tenants/TenantsSelect.jsx'
import PaymentRecurringSelect from '../../helpers/General/PaymentRecurringSelect'
import UnitedStatesSelect from '../../helpers/General/UnitedStatesSelect';

import { creditCardFormatter } from '../../helpers/General/CreditCardFormatter';

import { userBilling } from '../../core/controllers/UserBilling';
import { dropZone } from '../../core/utilities/DropZoneHandler';
import { modal } from '../../core/utilities/modal';

export default class BillingAccountForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            billingSetup : props.billingSetup,
            customerData: {
                customer_streetAddress: '',
                customer_city: '',
                customer_state: '',
                customer_name: '',
                customer_phone: '',
                customer_tenantId: props.tenantID,
                customer_account_number: '',
                customer_routing_number: '',
                customer_bank_type: 8,
                customer_card_number: '',
                customer_exp_month: '',
                customer_exp_year: '',
                customer_card_type: 0
            },
            addCard: false,
            addBank: true
        };
    }

    componentDidMount() {
    }

    componentWillUpdate(nextProps, nextState) {
    }

    resetData() {
        this.setState({
            customerData: {
                customer_streetAddress: '',
                customer_city: '',
                customer_state: '',
                customer_name: '',
                customer_phone: '',
                customer_tenantId: this.props.tenantID,
                customer_account_number: '',
                customer_routing_number: '',
                customer_bank_type: 8,
                customer_card_number: '',
                customer_exp_month: '',
                customer_exp_year: '',
                customer_card_type: 0
            }
        });
    }

    handleSaveBilling() {
        var self = this;
        if(this.state.addBank) {
            this.handleSaveACH();
            return;
        }

        const customerData = this.state.customerData;
        //const cardEvent = this.cardEvent;
        //const card = this.card;
        if(customerData.customer_card_number == '' || typeof customerData.customer_card_number == 'undefined') {
            modal.showInfo('Missing Information! We need a valid credit card.', 'warning', 'top', 'center');
            return;
        }
        if(customerData.customer_exp_month == '' || typeof customerData.customer_exp_month == 'undefined') {
            modal.showInfo('Missing Information! We need a valid expiration month.', 'warning', 'top', 'center');
            return;
        }
        if(customerData.customer_exp_year == '' || typeof customerData.customer_exp_year == 'undefined') {
            modal.showInfo('Missing Information! We need a valid expiration year.', 'warning', 'top', 'center');
            return;
        }
        if(customerData.customer_card_number.length != 19) {
            modal.showInfo('Missing Information! We need a valid credit card.', 'warning', 'top', 'center');
            return;
        }
        if(customerData.customer_card_type == '' || typeof customerData.customer_card_type == 'undefined') {
            modal.showInfo('Missing Information! What type of credit card is this?', 'warning', 'top', 'center');
            return;
        }

        var creditCard = {
            card_number: customerData.customer_card_number,
            card_type: customerData.customer_card_type,
            expiration: customerData.customer_exp_month + customerData.customer_exp_year
        };

        userBilling.saveBillingInformation(creditCard, function(response) {
            self.resetData();
            self.props.reload();
            modal.showSuccess("Success!",  "Your billing account has been setup successfully.  You can now enjoy Leasey!");
        });
    }

    handleSaveACH() {
        var self = this;
        const customerData = this.state.customerData;
        if(customerData.customer_routing_number == '' || typeof customerData.customer_routing_number == 'undefined') {
            modal.showInfo('Missing Information! We need the routing number.', 'warning', 'top', 'center');
            return;
        }
        if(customerData.customer_account_number == '' || typeof customerData.customer_account_number == 'undefined') {
            modal.showInfo('Missing Information! We need the account number.', 'warning', 'top', 'center');
            return;
        }
        if(customerData.customer_name == '' || typeof customerData.customer_name == 'undefined') {
            modal.showInfo('Missing Information! We need the account holder name.', 'warning', 'top', 'center');
            return;
        }

        // attach billing address to cardEvent
        var bankAccount = {
            country: 'us',
            currency: 'usd',
            routing_number: customerData.customer_routing_number,
            account_number: customerData.customer_account_number,
            account_holder_name: customerData.customer_name,
            account_holder_type: customerData.customer_bank_type
        };

        userBilling.saveBillingInformation(bankAccount, function(response) {
            self.resetData();
            self.props.reload();
            modal.showSuccess("Success!",  "Your billing account has been setup successfully.  You can now enjoy Leasey!");
        });
    }

    /* Customer Information */
    handleCustomerCityChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_city: {$set: e.target.value
                }}
            )
        });
    }

    handleCustomerStateChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_state: {$set: e.target.value
                }}
            )
        });
    }

    handleCustomerNameChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_name: {$set: e.target.value
                }}
            )
        });
    }

    handleCustomerAddressChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_streetAddress: {$set: e.target.value
                }}
            )
        });
    }

    handleCustomerCardNumber(e){
        var number = creditCardFormatter.format(e.target.value);

        this.setState({
            customerData: update(this.state.customerData, {
                customer_card_number: {$set: number
                }}
            )
        });
    }

    handleCustomerExpirationMonthChange(e){
        var month = e.target.value.replace(/\D/g,'');

        if(month.length > 2) {
            return;
        }

        this.setState({
            customerData: update(this.state.customerData, {
                customer_exp_month: {$set: month
                }}
            )
        });
    }

    handleCustomerExpirationYearChange(e){
        var year = e.target.value.replace(/\D/g,'');

        if(year.length > 2) {
            return;
        }

        this.setState({
            customerData: update(this.state.customerData, {
                customer_exp_year: {$set: year
                }}
            )
        });
    }

    handleCardTypeChange(e) {
        this.setState({
            customerData: update(this.state.customerData, {
                customer_card_type: {$set: e.target.value
                }}
            )
        });
    }

    /* ACH Information */
    handleCustomerRoutingNumberChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_routing_number: {$set: e.target.value
                }}
            )
        });
    }

    handleCustomerAccountNumberChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_account_number: {$set: e.target.value
                }}
            )
        });
    }

    handleCustomerBankType(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_bank_type: {$set: e.target.value
                }}
            )
        });
    }

    toggleACH(e) {
        this.setState({
            addBank: this.state.addBank ? false : true,
            addCard: this.state.addCard ? false : true
        });
    }

    toggleCreditCard(e) {
        this.setState({
            addCard: this.state.addCard ? false : true,
            addBank: this.state.addBank ? false : true
        });
    }

    handleCancelSubscription(e) {
        var self = this;
        userBilling.cancelSubscription(function(response) {
            self.props.reload();
            modal.resetBackDrop();
            modal.showSuccess('Subscription Cancelled!', 'Your subscription has been successfully cancelled.');
        });
    }

    handleReactivateSubscription(e) {
        var self = this;
        userBilling.reactivateSubscription(function(response) {
            self.props.reload();
            modal.resetBackDrop();
            modal.showSuccess('Subscription Re-Activated!', 'Your subscription has been successfully activated.');
        });
    }

    isNumberKey(evt){
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57))
            return false;
        return true;
    }

    render(){
        const customerData = this.state.customerData;
        return (
            <div>
            <div class="row">
                <div class="col-md-12">
                    <div class="alert alert-info">
                        <span><b>Choose your payment method.</b></span>
                    </div>
                </div>
                <div class="payment_option header" onClick={this.toggleACH.bind(this)}>
                    <h4 class="title"><i class="pe-7s-wallet"></i> ACH Setup</h4>
                    <p class="category">Recommended Method</p>
                </div>
                <form>
                <div class="col-md-12" style={{display: this.state.addBank ? 'block' : 'none' }}>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="phone">Routing Number</label>
                                <input type="text" value={customerData.customer_routing_number} class="form-control tenant-info" name="routing" placeholder="Routing Number" id="routing" onChange={this.handleCustomerRoutingNumberChange.bind(this)}/>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="phone">Account Number</label>
                                <input type="text" value={customerData.customer_account_number} class="form-control tenant-info" name="account" placeholder="Account Number" id="account" onChange={this.handleCustomerAccountNumberChange.bind(this)}/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="phone">Account Holder Name</label>
                                <input type="text" value={customerData.customer_name} class="form-control tenant-info" name="name" placeholder="Account Holder Name" id="name" onChange={this.handleCustomerNameChange.bind(this)}/>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="phone">Account Type</label>
                                <select class="form-control" value={customerData.bank_type} onChange={this.handleCustomerBankType.bind(this)}>
                                    <option value='8'>Checking Account</option>
                                    <option value='9'>Savings Account</option>
                                    <option value='10'>Corporate Checking Account</option>
                                    <option value='11'>Corporate Savings Account</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                </form>
            </div>
            <div class="row">
                <div class="payment_option header" onClick={this.toggleCreditCard.bind(this)}>
                    <h4 class="title"><i class="pe-7s-credit"></i> Credit Card Setup</h4>
                    <p class="category"></p>
                </div>
                <form>
                    <div class="col-md-12" style={{display: this.state.addCard ? 'block' : 'none' }}>
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="phone">Card Number</label>
                                    <input type="text" value={customerData.customer_card_number} class="form-control tenant-info" name="cardnumber" placeholder="Credit Card" id="cardnumber" onChange={this.handleCustomerCardNumber.bind(this)}/>
                                </div>
                            </div>
                            <div class="col-md-1">
                                <div class="form-group">
                                    <label for="phone">Expiration Month</label>
                                    <input type="text" value={customerData.customer_exp_month} class="form-control tenant-info" name="month" placeholder="01" id="month" onChange={this.handleCustomerExpirationMonthChange.bind(this)}/>
                                </div>
                            </div>
                            <div class="col-md-1">
                                <div class="form-group">
                                    <label for="phone">Expiration Year</label>
                                    <input type="text" value={customerData.customer_exp_year} class="form-control tenant-info" name="year" placeholder="22" id="year" onChange={this.handleCustomerExpirationYearChange.bind(this)}/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="cardtype">Card Type</label>
                                    <select class="form-control" value={customerData.bank_type} onChange={this.handleCardTypeChange.bind(this)}>
                                        <option value='0'>Select a Card Type</option>
                                        <option value='1'>American Express</option>
                                        <option value='2'>Visa</option>
                                        <option value='3'>MasterCard</option>
                                        <option value='4'>Diners Club</option>
                                        <option value='5'>Discover</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="row">
                <div class="content">
                    {this.props.billingSetup === true && this.props.subscriptionCanceled === false ? (
                        <div>
                            <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill pull-right" autoComplete="off" onClick={this.handleCancelSubscription.bind(this)}>
                            Cancel Subscription
                            </button>
                            <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off" onClick={this.handleSaveBilling.bind(this)}>
                            Save Billing
                            </button>
                        </div>
                    ) : (
                        <div>
                            { this.props.subscriptionCanceled === true ? (
                                <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill pull-right" autoComplete="off" onClick={this.handleReactivateSubscription.bind(this)}>
                                Reactivate Subscription
                                </button>
                            ) : (
                                <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off" onClick={this.handleSaveBilling.bind(this)}>
                                Save Billing
                                </button>
                            )}
                        </div>
                    )}
                    <div class="clearfix"></div>
                </div>
            </div>
            </div>
        );
    }
};


// WEBPACK FOOTER //
// app/components/Billing/BillingAccountForm.jsx